import React from 'react';

import { HokiSkateboards } from './HokiSkateboards/HokiSkateboards';

export const PassionPage = () => (
	<div className="passion" id="container">
		<div className="boxed boxed-lg">
			<h1 className="bottom-border">Passion Project</h1>
			<HokiSkateboards />
		</div>
	</div>
);
